import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmployerLocation } from '../Models/EmployerLocation';
import { QuestionProcessingService } from '../services/question-processing.service';
import { TouchEventService } from '../services/touch-event.service';
import { timer } from 'rxjs/observable/timer';
import { BaseComponent } from '../Models/BaseComponent';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent extends BaseComponent implements OnInit {

  _location: Router;
  _question : QuestionProcessingService;
  selectedLocation : EmployerLocation;
  
  locations : EmployerLocation[] = [
    { loc_Code: 100, loc_Name: "Headquarters" },
    { loc_Code: 102, loc_Name: "Field Office 1" },
    { loc_Code: 143, loc_Name: "Field Office 2" },
    { loc_Code: 544, loc_Name: "Distribution Center 1" },
    { loc_Code: 775, loc_Name: "Distribution Center 2" }
  ];
  constructor(public location : Router, private question : QuestionProcessingService, public swiper : TouchEventService) {
    super(swiper,location);
    this._location = location;
    this.questions = question;
    this.swiper.publisher.subscribe((args: any) => {
      console.log('swiping in direction : ', args);
      if(args == 'next')this.continue();
    })
  }
  
  ngOnInit() {
    console.log(this.selectedLocation);
    document.getElementsByClassName('container')[0].classList.remove('slide-backward');
    document.getElementsByClassName('container')[0].classList.add('slide-forward');
    var tim = timer(0);
    tim.subscribe(t => {
      document.getElementsByClassName('container')[0].classList.remove('slide-forward');
    })
  }

  continue() : void {
    if(!this.selectedLocation){
      this.validationError = true;
      return;
    }
    this._location.navigateByUrl('/lookup');
  }

  setLocation(loc : EmployerLocation) {
    console.log(this.selectedLocation);
    this.selectedLocation = loc;
  }

  help() : void {
   console.log('help')
  }

}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/landing-page/landing-page.component.ts